import queryString from 'query-string';
import { HomesList, HomesListParams } from 'src/features/listing-page/types';
import { apiClient } from 'src/utils/api-client';
import type { ApiClient } from 'src/utils/api-client';
import {
  HomeMapPinModel,
  HomePlacementRequirementsPlatformModel,
  Location,
  OwnerOnboardingModel,
  UnitListingDetailsModel,
} from './models';

export function fetchHomesService(
  filters: HomesListParams,
  client: ApiClient = apiClient,
) {
  return client.get<HomesList>(`/homes?${queryString.stringify(filters)}`);
}

export function fetchRelatedHomesService(
  homeId: string,
  client: ApiClient = apiClient,
) {
  return client.get<HomesList>(`/homes/${homeId}/related-units`);
}

export function fetchHomeService(
  homeId: string,
  client: ApiClient = apiClient,
) {
  return client.get<UnitListingDetailsModel>(`/homes/${homeId}`);
}

export function fetchAvailableLocationsListService(
  client: ApiClient = apiClient,
) {
  return client.get<Location[]>('/homes/available-locations');
}

export function fetchHomePinsService(
  request: HomesListParams,
  client: ApiClient = apiClient,
) {
  return client.get<HomeMapPinModel[]>(
    `/homes/map-pins?${queryString.stringify(request)}`,
  );
}

export function putHomePlacementsRequirementsService(
  body: HomePlacementRequirementsPlatformModel,
  client: ApiClient = apiClient,
) {
  return client.put<OwnerOnboardingModel>(
    `/platform/home/placement-requirements`,
    body,
  );
}
